import React, {FC} from 'react';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {ReactComponent as OfflineIcon} from '../../assets/i/offline.svg';
import {useAppDispatch} from 'common/hook';
import {isFoolPopupServiceAC, setPopupsOfflineAC} from "app/popups-reducer";
import './style.css'


export const PopupsOffline: FC = () => {
    const dispatch = useAppDispatch();

    const onClickHandler = () => {
        dispatch(setPopupsOfflineAC(false));
        dispatch(isFoolPopupServiceAC(false))
    };



    return (
        <>
            <p className="h3 popup-title">Обратная связь</p>
            <form action="#" className="form">
                <div className='offline-popup'>
                    <span className='offline-popup-icon'><OfflineIcon/></span>
                    <div className='offline-popup-text'>
                        <span>Вы сейчас находитесь офлайн.</span>
                        <span>Мы сохранили ваше сообщение и отправим его, как только вы будете онлайн.</span>
                    </div>
                </div>
            </form>
            <span className="js-close-popup" onClick={onClickHandler}>
                <CloseIcon/>
            </span>
        </>
    );
};
